import { Button, Chip } from '@heroui/react';
import { FaFire } from "react-icons/fa";

type HorizontalSelectorOption<T extends string | number> = {
  value: T;
  label: string;
  locked?: boolean;
};

type HorizontalSelectorProps<T extends string | number> = {
  value: T;
  options: HorizontalSelectorOption<T>[];
  label?: string;
  onChange: (v: T) => void;
};

export function HorizontalSelector<T extends string | number>({
  value,
  options,
  label,
  onChange,
}: HorizontalSelectorProps<T>) {
  return (
    <div className="flex flex-row items-center rounded-md bg-zinc-100 dark:bg-zinc-800">
      {options.map((opt) => (
        <Button
          key={String(opt.value)}
          size="sm"
          variant={value === opt.value ? 'solid' : 'light'}
          color={value === opt.value ? 'primary' : 'default'}
          isDisabled={opt.locked}
          onPress={() => onChange(opt.value)}
          className={opt.locked ? 'text-orange-500 opacity-100' : ''}
        >
          <span className="flex items-center gap-1">
            {opt.label}
            {opt.locked && <FaFire />}
          </span>
        </Button>
      ))}
      {label && <span className={'text-sm px-2'}>{label}</span>}
    </div>
  );
}
